import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Collapse from '@material-ui/core/Collapse';
import Financeiro from './financeiro';
import Geral from './geral';

function Relatorios() {
  const [aba, setAba] = useState(1);
  const [abas, setAbas] = useState([
    { label: 'GERAL', value: 1 },
    { label: 'FINANCEIRO', value: 2 },
  ]);

  const handleChange = (event, newValue) => {
    setAba(newValue);
  };

  return (
    <Paper>
      <Tabs
        value={aba}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        aria-label="Abas"
      >
        {abas.map((a) => (
          <Tab value={a.value} label={a.label} />
        ))}
      </Tabs>
      <Collapse in={aba === 1}>
        <Geral />
      </Collapse>
      <Collapse in={aba === 2}>
        <Financeiro />
      </Collapse>
    </Paper>
  );
}

export default Relatorios;
